import { useT } from "@/app/translations/useT";
import { UStyles } from "@/app/utils/UStyles";
import { coverTags } from "./BlogCover.logic";
import styles from "./BlogCover.module.css";

type Props = {
  seed: number;
};

export default function BlogCoverTags(props: Props) {
  const { seed } = props;
  const T = useT();

  return (
    <span className={styles.tags}>
      {coverTags(seed).map((tag) => (
        <span key={tag.labelKey} className={UStyles.classNames(styles.tag, styles[tag.toneClass])}>
          {T(tag.labelKey)}
        </span>
      ))}
    </span>
  );
}
